import React, { useEffect } from 'react';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import {
	REMINDER_NOTIFICATIONS_COUNT,
	UNREAD_NOTIFICATION_TYPES,
	UNREAD_REMINDER_NOTIFICATIONS,
} from '../../utils/NotificationUtils';
import { isWorkOrderRemindersEnabled } from '../../data/workOrderStarLabels';
import useWorkOrderStarSocket, {
	isReminderDueOrReconnect,
} from '../../hooks/useWorkOrderStarSocket';

type FetchCount = (params: Record<string, unknown>, countName?: string | null) => unknown;

/**
 * The Inbox's Reminders tab for the buyer and supplier overview pages: loads its unread count with
 * the user, refreshes it (and Important's, which it adds to) when a reminder comes due, and returns
 * the tab entry to spread into the page's tabs — none with reminders off (Work-Order-Reminders).
 */
const useRemindersInboxTab = (currentUser, userNotifications, fetchCount: FetchCount) => {
	const enabled = isWorkOrderRemindersEnabled();

	useEffect(() => {
		if (currentUser && enabled) {
			fetchCount(UNREAD_REMINDER_NOTIFICATIONS, REMINDER_NOTIFICATIONS_COUNT);
		}
	}, [currentUser, enabled, fetchCount]);

	useWorkOrderStarSocket((message) => {
		if (!currentUser || !enabled || !isReminderDueOrReconnect(message)) return;
		fetchCount(UNREAD_REMINDER_NOTIFICATIONS, REMINDER_NOTIFICATIONS_COUNT);
		fetchCount(UNREAD_NOTIFICATION_TYPES, 'TASKS_NOTIFICATIONS');
	});

	if (!enabled) return [];
	const unreadCount = nullSafeGet(`counts.${REMINDER_NOTIFICATIONS_COUNT}`, userNotifications);
	return [
		{
			key: 'reminders',
			name: unreadCount ? (
				<>
					Reminders <span className="text-base">({unreadCount})</span>
				</>
			) : (
				'Reminders'
			),
		},
	];
};

export default useRemindersInboxTab;
